import { MessageCircle } from "lucide-react";
import { useConfig } from "../lib/config";

const FALLBACK_WHATSAPP = "+905057453532";

export default function WhatsAppFloat() {
  const cfg = useConfig();
  const number = (cfg.whatsapp || FALLBACK_WHATSAPP).replace(/\D/g, "");
  if (!number) return null;
  const link = `https://wa.me/${number}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-[60] bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl flex items-center gap-2 px-4 py-3 rounded-full transition-transform hover:-translate-y-0.5"
      aria-label="WhatsApp ile iletişim"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
}
